import React, { useState } from "react";
import useReduxState from "src/hooks/useReduxState";
import { useProductInventoryStore } from "src/hooks/productInventory";
import {useCartStore} from "src/hooks/cart";
import AxiosIndicatorRunTimeLoader from "../../AxiosIndicatorRunTimeLoader";
import { useAlertStore } from "src/hooks/Alert";

export const NotifyMe = (props) => {
    const { single_product, fetch_stock_alert_products_details } = props;
    const [stockAlertSingleLoader, setStockAlertSingleLoader] = useState(false)
    const [stockAlertState] = useReduxState({}, "setStockAlertState");
    const [{ CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER }] = useCartStore();
    const [,, { set_stock_alert_notification }] = useProductInventoryStore();
    const [,, { delete_stock_alert }] = useAlertStore();

    const handleNotify = async ({ target }) => {
        const value = target.checked;
        setStockAlertSingleLoader(true)
        if(value){
            const alertRes = await set_stock_alert_notification(
                { "erpPartNumber": single_product?.ERPPartNumber,
                    "itemNumber": single_product?.ItemNumber,
                    "erpMfrPartNumber": single_product?.ERPMFRPartNumber,
                    "erpManufacturerCode": single_product?.ERPManufacturerCode,
                    "customerPartNumber": CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[single_product?.ItemNumber]?.CUSTOMER_PART_NUMBER,
                    "erpManufacturerName": single_product?.ERPManufacturerName,
                    "manufacturerName": single_product?.ManufacturerName
                })
        } else {
            const deleteRes = await delete_stock_alert(stockAlertState[single_product?.ItemNumber]?.stockAlertId);
        }
        await fetch_stock_alert_products_details();
        setStockAlertSingleLoader(false)
    }

    return  <div className="form-check notifymepart">
        <label className="form-check-label" htmlFor={'notify_' + single_product?.ItemNumber}>Notify me, when part comes available</label>
        {stockAlertSingleLoader ? <AxiosIndicatorRunTimeLoader /> : <input type="checkbox" checked={!!stockAlertState[single_product?.ItemNumber]} onChange={handleNotify} className="form-check-input" id={'notify_' + single_product?.ItemNumber} />}
    </div>;
}